import React, { useContext } from 'react';

import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import PasswordField from 'material-ui-password-field';

import { useTranslation } from 'react-i18next';

import { StyledButton } from '../../../components/button/Button';

import UserContext from '../../../context/UserContext';


export default function Login() {
  const { t } = useTranslation();
  const { userToken } = useContext(UserContext);

  const [isFeedback, setIsFeedback] = React.useState(false);
  const [isResetPass, setIsResetPass] = React.useState(true);

  const [state, setState] = React.useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
    error: false,
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const { old_password, new_password, confirm_password } = state;

    fetch(`${process.env.REACT_APP_BACKOFFICE_API_URL}/api/v1/passsword/change`, {
      method: 'post',
      headers: {
        'Authorization': userToken.token_type + ' ' + userToken.access_token,
        Accept: 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        old_password: old_password,
        new_password: new_password,
        confirm_password: confirm_password,
      }),
    })
      .then(function(response) {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        if ( response.success !== undefined && response.success === false) {
          setState({ ...state, error: response.message });
        } else {
          setIsFeedback(!isFeedback);
          setIsResetPass(false);
        }
        
        return response;
      });
  };

  function Feedback() {
    return (
      <>
        <Grid item align="center">
          <Typography variant="h6" style={{ fontSize: '12px', color: '#555' }}>{t('ดำเนินการเปลี่ยนรหัสผ่าน')}</Typography>
          <Typography variant="h6" style={{ fontSize: '12px', color: '#555' }}>
            <Typography variant="h6" color="primary" style={{ fontSize: '12px' }} display="inline">{t('เรียบร้อยแล้ว')}</Typography>
          </Typography>
        </Grid>
      </>
    );
  }

  return (
    <>
      {isResetPass && (
        <>
          <Box color="error.main">{state.error}</Box>
          <Grid container direction="column" spacing={5} style={{ marginTop: 10 }}>
            <Grid item md>
              <FormControl required>
                <Typography variant="h6" style={{ fontSize: '16px', color: '#555' }}>{t('รหัสผ่านเดิม')}</Typography>
                <PasswordField name="old_password" id="old_password" onChange={onChange}/>
              </FormControl>
            </Grid>
            <Grid item md>
              <FormControl required>
                <Typography variant="h6" style={{ fontSize: '16px', color: '#555' }}>{t('รหัสผ่านใหม่')}</Typography>
                <PasswordField name="new_password" id="new_password" onChange={onChange}/>
              </FormControl>
            </Grid>
            <Grid item md>
              <FormControl required>
                <Typography variant="h6" style={{ fontSize: '16px', color: '#555' }}>{t('ยืนยันรหัสผ่านใหม่')}</Typography>
                <PasswordField name="confirm_password" id="confirm_password" onChange={onChange}/>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item align="center">
            <FormControl style={{ width: '70%', marginTop: 30 }}>
              <StyledButton onClick={onSubmit}>
              {t('ตกลง')}
              </StyledButton>
            </FormControl>
          </Grid>
        </>
      )}
      {isFeedback && <Feedback />}
    </>
  );
}
